// Sevkiyat / Transfer / Sipariş belgesi — A4 yazdırma (izole yeni pencere) + WhatsApp paylaşımı.
// Tek sipariş veya ÇOKLU sipariş (toplu güzergah belgesi) + kayıtlı araç/şoför ataması destekler.
import { logoUrl, docImageUrl, docStampUrl, docStampPos, docCfg, verifyUrl, docBrandName, docSlogan, activeDocTemplate } from "@/lib/company";
import QRCode from "qrcode";

const OTYPE_TITLE = {
  purchase_order: "SATIN ALMA SİPARİŞ / SEVK FİŞİ",
  internal_order: "İÇ İKMAL SEVK FİŞİ",
  transfer: "TRANSFER / SEVK İRSALİYESİ",
};
const OTYPE_SHORT = { purchase_order: "Satın Alma", internal_order: "İç İkmal", transfer: "Transfer" };
const STATUS_TR = {
  requested: "Talep", approved: "Onaylandı", in_transit: "Yolda (Sevk edildi)",
  completed: "Tamamlandı", rejected: "Reddedildi", cancelled: "İptal",
};

const dt = (iso) => {
  if (!iso) return "—";
  try { return new Date(iso).toLocaleString("tr-TR", { day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit" }); }
  catch { return String(iso); }
};
const fmtNum = (v) => (v === null || v === undefined || v === "") ? "—" : Number(v).toLocaleString("tr-TR", { maximumFractionDigits: 3 });
const esc = (s) => String(s ?? "").replace(/[&<>"]/g, (c) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c]));
const asArray = (x) => Array.isArray(x) ? x.filter(Boolean) : (x ? [x] : []);

function qrSvg(text, px = 74) {
  try {
    const qr = QRCode.create(String(text || "-"), { errorCorrectionLevel: "M" });
    const n = qr.modules.size;
    const data = qr.modules.data;
    const cell = px / n;
    let rects = "";
    for (let r = 0; r < n; r++) {
      for (let c = 0; c < n; c++) {
        if (data[r * n + c]) rects += `<rect x="${(c * cell).toFixed(2)}" y="${(r * cell).toFixed(2)}" width="${cell.toFixed(2)}" height="${cell.toFixed(2)}"/>`;
      }
    }
    return `<svg width="${px}" height="${px}" viewBox="0 0 ${px} ${px}" xmlns="http://www.w3.org/2000/svg" shape-rendering="crispEdges"><rect width="${px}" height="${px}" fill="#fff"/><g fill="#000">${rects}</g></svg>`;
  } catch (e) { return ""; }
}

const route = (o) => o.order_type === "purchase_order"
  ? `${o.supplier || "-"} → ${o.to_location_name || "-"}`
  : `${o.from_location_name || "-"} → ${o.to_location_name || "-"}`;

function driverBlock(vehicle) {
  if (vehicle) {
    return `<div class="drv">
      <span><b>Şoför:</b> ${esc(vehicle.driver_name || "—")}</span>
      <span><b>Telefon:</b> ${esc(vehicle.driver_phone || "—")}</span>
      <span><b>Araç / Plaka:</b> ${esc(vehicle.plate || "—")}${vehicle.vehicle_type ? ` (${esc(vehicle.vehicle_type)})` : ""}</span>
      <span><b>Çıkış Saati:</b> __________</span>
    </div>`;
  }
  return `<div class="drv">
    <span><b>Şoför / Sürücü:</b> ____________________</span>
    <span><b>Araç / Plaka:</b> ____________________</span>
    <span><b>Çıkış Saati:</b> __________</span>
  </div>`;
}

function supplierBlock(o) {
  if (o.order_type !== "purchase_order") return "";
  const s = o.supplier_info || {};
  const taxLbl = s.type === "individual" ? "T.C. Kimlik No" : "VKN";
  const loc = [s.district, s.province].filter(Boolean).join(" / ");
  return `<div class="party">
    <div class="plbl">Tedarikçi</div>
    <div class="pnm">${esc(o.supplier || s.name || "—")}${s.code ? ` <small>(${esc(s.code)})</small>` : ""}</div>
    ${s.tax_no ? `<div class="psm">${taxLbl}: <b>${esc(s.tax_no)}</b>${s.tax_office ? ` · ${esc(s.tax_office)}` : ""}</div>` : ""}
    ${loc ? `<div class="psm">${esc(loc)}</div>` : ""}
    ${s.address ? `<div class="psm">${esc(s.address)}</div>` : ""}
    ${(s.phone || s.email) ? `<div class="psm">${s.phone ? `Tel: ${esc(s.phone)}` : ""}${s.phone && s.email ? " · " : ""}${s.email ? esc(s.email) : ""}</div>` : ""}
  </div>`;
}

function itemsRows(o) {
  return (o.lines || []).map((l, i) => `
    <tr>
      <td class="c">${i + 1}</td>
      <td class="mono">${esc(l.sku || "—")}</td>
      <td>${esc(l.name || "")}</td>
      <td class="c">${esc(l.unit || "adet")}</td>
      <td class="r">${fmtNum(l.qty_requested)}</td>
      <td class="r">${fmtNum(l.qty_shipped)}</td>
      <td class="r box"></td>
    </tr>`).join("");
}

function orderSection(o, vehicle, printedAt, pageBreak, cfg) {
  const title = cfg.title || OTYPE_TITLE[o.order_type] || "SEVK FİŞİ";
  return `<section class="page${pageBreak ? " pbrk" : ""}">
  <div class="hd">
    <div class="brand">${cfg.show_logo ? `<img class="dlogo" src="${logoUrl()}" alt="${esc(docBrandName())}"/>` : ""}${cfg.show_brand ? `<span>${esc(docBrandName())}<small>${esc(docSlogan())}</small></span>` : ""}</div>
    <div class="doc-title">${cfg.qr_verify ? `<div class="dqr">${qrSvg(verifyUrl(o.transfer_no || ""), 70)}<span>Doğrula</span></div>` : ""}<b>${title}</b><div class="no">${esc(o.transfer_no || "")}</div><div>${STATUS_TR[o.status] || esc(o.status)}</div></div>
  </div>
  ${cfg.header_lines.length ? `<div class="dhdr">${cfg.header_lines.map((l) => `<div>${esc(l)}</div>`).join("")}</div>` : ""}
  ${cfg.stamp && docStampPos() === "top" ? `<div class="dstampwrap" style="text-align:center;margin-top:6px;">${docStampUrl() ? `<img src="${docImageUrl(docStampUrl())}" alt="Kaşe & İmza" style="max-height:80px;max-width:170px;display:inline-block;"/>` : `<span class="dstamp">RESMÎ BELGE<br/><small style="font-size:9px;letter-spacing:1px;">${esc(docBrandName())}</small></span>`}</div>` : ""}
  <div class="meta">
    <div class="box1">
      <div class="row"><span class="k">Belge No</span><span class="v">${esc(o.transfer_no || "—")}</span></div>
      <div class="row"><span class="k">Oluşturma</span><span class="v">${dt(o.created_at)}</span></div>
      ${o.approved_at ? `<div class="row"><span class="k">Onay</span><span class="v">${dt(o.approved_at)}</span></div>` : ""}
      ${o.shipped_at ? `<div class="row"><span class="k">Sevk</span><span class="v">${dt(o.shipped_at)}</span></div>` : ""}
    </div>
    <div class="box1">
      <div class="row"><span class="k">Nereden</span><span class="v">${esc(o.order_type === "purchase_order" ? (o.supplier || "-") : (o.from_location_name || "-"))}</span></div>
      <div class="row"><span class="k">Nereye</span><span class="v">${esc(o.to_location_name || "-")}</span></div>
      <div class="row"><span class="k">Kalem Sayısı</span><span class="v">${(o.lines || []).length}</span></div>
    </div>
  </div>
  ${supplierBlock(o)}
  ${driverBlock(vehicle)}
  <table>
    <thead><tr>
      <th style="width:26px">#</th><th style="width:80px">Stok Kodu</th><th>Ürün</th>
      <th style="width:52px">Birim</th><th style="width:60px">Talep</th><th style="width:60px">Sevk</th><th style="width:80px">Fiziki Sayım</th>
    </tr></thead>
    <tbody>${itemsRows(o)}</tbody>
  </table>
  ${o.note ? `<div class="note"><b>Not:</b> ${esc(o.note)}</div>` : ""}
  ${o.discrepancy ? `<div class="warn">Eksik/fark teslim: ${esc(o.discrepancy_note || "")}</div>` : ""}
  <div class="sign">
    <div><div class="sline"></div>Teslim Eden (Sevkiyat)<br/>Ad-Soyad / İmza</div>
    <div><div class="sline"></div>Şoför / Taşıyan<br/>Ad-Soyad / Plaka / İmza</div>
    <div><div class="sline"></div>Teslim Alan (Mal Kabul)<br/>Ad-Soyad / İmza</div>
  </div>
  ${cfg.stamp && docStampPos() !== "top" ? `<div class="dstampwrap" style="text-align:${docStampPos()}">${docStampUrl() ? `<img src="${docImageUrl(docStampUrl())}" alt="Kaşe & İmza" style="max-height:80px;max-width:170px;display:inline-block;"/>` : `<span class="dstamp">RESMÎ BELGE<br/><small style="font-size:9px;letter-spacing:1px;">${esc(docBrandName())}</small></span>`}</div>` : ""}
  ${cfg.footer_lines.length ? `<div class="dftr">${cfg.footer_lines.map((l) => `<div>${esc(l)}</div>`).join("")}</div>` : ""}
  <div class="ft"><span>Güzergah: ${esc(route(o))}</span><span>Yazdırma: ${printedAt} · <b>Groot Market</b> Bulut ERP</span></div>
</section>`;
}

function coverPage(orders, vehicle, printedAt, cfg) {
  const rows = orders.map((o, i) => `
    <tr>
      <td class="c">${i + 1}</td>
      <td class="mono">${esc(o.transfer_no || "—")}</td>
      <td>${esc(OTYPE_SHORT[o.order_type] || "Sevk")}</td>
      <td>${esc(route(o))}</td>
      <td class="r">${(o.lines || []).length}</td>
      <td>${esc(STATUS_TR[o.status] || o.status)}</td>
    </tr>`).join("");
  const totalItems = orders.reduce((s, o) => s + (o.lines || []).length, 0);
  return `<section class="page pbrk">
  <div class="hd">
    <div class="brand">${cfg.show_logo ? `<img class="dlogo" src="${logoUrl()}" alt="${esc(docBrandName())}"/>` : ""}${cfg.show_brand ? `<span>${esc(docBrandName())}<small>${esc(docSlogan())}</small></span>` : ""}</div>
    <div class="doc-title"><b>TOPLU SEVK BELGESİ</b><div class="no">${orders.length} SEVKİYAT</div><div>${printedAt}</div></div>
  </div>
  ${driverBlock(vehicle)}
  <table>
    <thead><tr>
      <th style="width:26px">#</th><th style="width:110px">Belge No</th><th style="width:90px">Tür</th>
      <th>Güzergah</th><th style="width:60px">Kalem</th><th style="width:110px">Durum</th>
    </tr></thead>
    <tbody>${rows}</tbody>
  </table>
  <div class="note"><b>Toplam:</b> ${orders.length} sevkiyat · ${totalItems} kalem. Sonraki sayfalarda her sevkiyatın detay fişi yer alır.</div>
  <div class="sign">
    <div><div class="sline"></div>Sevkiyat Sorumlusu<br/>Ad-Soyad / İmza</div>
    <div><div class="sline"></div>Şoför / Taşıyan<br/>Ad-Soyad / Plaka / İmza</div>
  </div>
  <div class="ft"><span>Toplu güzergah belgesi</span><span>Yazdırma: ${printedAt} · <b>Groot Market</b> Bulut ERP</span></div>
</section>`;
}

const CSS = `
  * { box-sizing: border-box; }
  body { font-family: Arial, "Segoe UI", sans-serif; color: #0f172a; margin: 0; font-size: 12px; -webkit-print-color-adjust: exact; print-color-adjust: exact; }
  .page { padding: 12mm; }
  .pbrk { page-break-after: always; }
  .hd { display:flex; justify-content:space-between; align-items:center; border-bottom:3px solid #064E3B; padding:12px 14px; margin-bottom:14px; background:linear-gradient(90deg,#ECFDF5,#ffffff); border-radius:10px 10px 0 0; }
  .brand { display:flex; align-items:center; gap:12px; font-size:18px; font-weight:800; color:#064E3B; letter-spacing:.3px; }
  .dlogo { height:44px; width:auto; display:block; }
  .brand small { display:block; font-size:9.5px; font-weight:700; color:#EA580C; letter-spacing:2px; margin-top:2px; text-transform:uppercase; }
  .dhdr { margin:0 0 10px; padding:6px 10px; border-left:3px solid #EA580C; background:#fff7ed; border-radius:0 6px 6px 0; font-size:11px; color:#334155; }
  .dhdr div { line-height:1.5; }
  .dftr { margin-top:12px; padding:6px 10px; border-top:1px dashed #94a3b8; font-size:11px; color:#475569; text-align:center; }
  .dftr div { line-height:1.5; }
  .dqr { margin-bottom:4px; text-align:right; }
  .dqr svg { display:inline-block; }
  .dqr span { display:block; font-size:8px; color:#64748b; letter-spacing:1px; text-transform:uppercase; }
  .dstampwrap { text-align:center; margin-top:14px; }
  .dstamp { display:inline-block; transform:rotate(-5deg); border:2px solid #064E3B; color:#064E3B; border-radius:8px; padding:6px 16px; font-size:11px; font-weight:800; letter-spacing:2px; line-height:1.4; }
  .doc-title { text-align:right; }
  .doc-title b { font-size:15px; color:#064E3B; letter-spacing:.3px; }
  .doc-title .no { font-family:monospace; font-size:13px; font-weight:700; color:#0f172a; }
  .doc-title > div:last-child { display:inline-block; margin-top:3px; padding:2px 9px; border-radius:999px; background:#EA580C; color:#fff; font-size:10px; font-weight:700; }
  .meta { display:flex; gap:14px; margin:12px 0; }
  .box1 { flex:1; border:1px solid #d5e0da; border-radius:8px; padding:8px 10px; }
  .box1 .row { display:flex; justify-content:space-between; padding:3px 0; border-bottom:1px dotted #e5e5e5; }
  .box1 .row:last-child { border-bottom:0; }
  .box1 .k { color:#64748b; } .box1 .v { font-weight:700; }
  .drv { border:1px dashed #94a3b8; border-radius:8px; padding:8px 10px; margin-bottom:10px; display:flex; gap:18px; flex-wrap:wrap; font-size:12px; background:#f8fafc; }
  .party { border:1px solid #f0c99a; background:#fff7ed; border-left:4px solid #EA580C; border-radius:8px; padding:8px 11px; margin-bottom:10px; }
  .party .plbl { font-size:9px; text-transform:uppercase; letter-spacing:1px; color:#EA580C; font-weight:700; margin-bottom:2px; }
  .party .pnm { font-weight:800; font-size:13px; color:#0f172a; }
  .party .pnm small { font-weight:600; color:#64748b; font-size:11px; }
  .party .psm { font-size:10.5px; color:#475569; line-height:1.5; }
  table { width:100%; border-collapse:collapse; margin-top:4px; }
  th, td { border:1px solid #cfd8d3; padding:6px; }
  th { background:#e8f1ec; color:#064E3B; text-align:left; font-size:11px; text-transform:uppercase; letter-spacing:.3px; border-color:#064E3B; }
  td.c { text-align:center; } td.r { text-align:right; } td.mono { font-family:monospace; font-size:11px; } td.box { background:#fafafa; }
  .note { margin-top:10px; font-size:12px; border-left:3px solid #064E3B; padding:5px 10px; background:#f0f7f3; border-radius:0 6px 6px 0; } .note b { color:#064E3B; }
  .warn { margin-top:8px; border:1px solid #e0b400; background:#fff8e1; padding:6px 10px; border-radius:6px; color:#8a6d00; }
  .sign { display:flex; gap:16px; margin-top:26px; }
  .sign > div { flex:1; text-align:center; font-size:11px; color:#475569; }
  .sline { border-top:1px solid #334155; margin-bottom:5px; height:40px; }
  .ft { margin-top:16px; padding-top:6px; border-top:2px solid #064E3B; font-size:10px; color:#64748b; display:flex; justify-content:space-between; }
  .ft b { color:#064E3B; }
  body[data-template="minimal"] .hd { background:#fff; border-bottom:2px solid #0A0A0A; }
  body[data-template="minimal"] th { background:#fff; color:#0A0A0A; border-color:#0A0A0A; }
  body[data-template="modern"] .hd { border-bottom-width:5px; }
  body[data-template="modern"] th { text-transform:uppercase; letter-spacing:.6px; }
  body[data-template="zarif"] { font-family:'Georgia','Times New Roman',serif; }
  body[data-template="kompakt"] { font-size:10.5px; }
  body[data-template="kompakt"] .page { padding:8mm; }
  body[data-template="kutu"] .hd { border:1.5px solid #064E3B; border-radius:10px; }
  body[data-template="kurumsal"] .hd { border-bottom:3px double #064E3B; }
  @page { size:A4; margin:0; }
`;

export function buildDispatchHTML(ordersInput, opts = {}) {
  const orders = asArray(ordersInput);
  if (!orders.length) return "";
  const vehicle = opts.vehicle || null;
  const cfg = opts.docConfig || docCfg("dispatch");
  const printedAt = dt(new Date().toISOString());
  const body = orders.length > 1
    ? coverPage(orders, vehicle, printedAt, cfg) + orders.map((o, i) => orderSection(o, vehicle, printedAt, i < orders.length - 1, cfg)).join("")
    : orderSection(orders[0], vehicle, printedAt, false, cfg);
  const title = orders.length > 1 ? `Toplu Sevk (${orders.length})` : (orders[0].transfer_no || "Sevk Fişi");
  return `<!doctype html><html lang="tr"><head><meta charset="utf-8"><title>${esc(title)}</title><style>${CSS}</style></head><body data-template="${activeDocTemplate()}">${body}</body></html>`;
}

export function printDispatch(ordersInput, opts = {}) {
  const html = buildDispatchHTML(ordersInput, opts);
  if (!html) return false;
  const w = window.open("", "_blank", "width=920,height=1000");
  if (!w) return false;
  w.document.open();
  w.document.write(html);
  w.document.close();
  w.focus();
  setTimeout(() => { try { w.print(); } catch (e) { /* kullanıcı kapatmış olabilir */ } }, 600);
  return true;
}

export function whatsappDispatch(ordersInput, opts = {}) {
  const orders = asArray(ordersInput);
  if (!orders.length) return;
  const vehicle = opts.vehicle || null;
  const veh = vehicle ? `\nŞoför/Araç: ${vehicle.driver_name || "—"} · ${vehicle.plate || "—"}` : "";
  let text;
  if (orders.length === 1) {
    const o = orders[0];
    const items = (o.lines || []).map((l) => `• ${l.name} — ${fmtNum(l.qty_requested)} ${l.unit || "adet"}`).join("\n");
    const title = OTYPE_TITLE[o.order_type] || "SEVK FİŞİ";
    text = `*${docBrandName()}*\n${title}\nBelge No: ${o.transfer_no}\nGüzergah: ${route(o)}\nDurum: ${STATUS_TR[o.status] || o.status}\nTarih: ${dt(o.created_at)}${veh}\n\nKalemler:\n${items}\n${o.note ? `\nNot: ${o.note}` : ""}\n\n${docBrandName()}`;
  } else {
    const lines = orders.map((o, i) => `${i + 1}. ${o.transfer_no} · ${route(o)} · ${(o.lines || []).length} kalem`).join("\n");
    text = `*${docBrandName()}*\nTOPLU SEVK BELGESİ (${orders.length} sevkiyat)${veh}\n\n${lines}\n\n${docBrandName()}`;
  }
  window.open(`https://wa.me/?text=${encodeURIComponent(text)}`, "_blank");
}
